import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import {Stack} from "@mui/material";

const severityColors = {
    low: "info",
    medium: "warning",
    high: "error",
};

export default function Alert({ station, title, message, severity }) {
    return (
        <Accordion sx={{width:'60%'}}>
            <AccordionSummary expandIcon={<ExpandMore/>}>
                <Stack direction={'row'} spacing={8}>
                    <Typography color={severityColors[severity]}>{station}</Typography>
                    <Typography color={severityColors[severity]}>{title}</Typography>
                </Stack>
            </AccordionSummary>
            <AccordionDetails>{message}</AccordionDetails>
        </Accordion>
    );
}
